import React from 'react';
import './product-image.scss';
import { SVGS } from '../../assets';
import { useState, useLayoutEffect } from 'react';

interface ProductImageProps {
  productImage: string;
  size?: string;
  filter?: any;
}

export const ProductImage: React.FC<ProductImageProps> = ({
  productImage,
  size = '48',
  filter,
}) => {
  const [imageSrc, setImageSrc] = useState(SVGS.DefaultProduct);
  const [isLoading, setIsLoading] = useState(true);

  useLayoutEffect(() => {
    setIsLoading(true);
    if (productImage === '') {
      setIsLoading(false);
      return;
    }
    if (productImage) {
      setImageSrc(getModifiedImageUrl(productImage));
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  }, [productImage]);

  const getModifiedImageUrl = (url: string) => {
    if (!url || !url.trim()) return SVGS.DefaultProduct;

    try {
      const urlObj = new URL(url);
      urlObj.searchParams.set('width', size);
      urlObj.searchParams.delete('height');
      const modifiedUrl = urlObj.toString();

      return modifiedUrl;
    } catch (error) {
      console.warn(`Invalid image URL: ${url}`, error);
      return SVGS.DefaultProduct;
    }
  };

  return (
    <img
      src={isLoading ? SVGS.DefaultProduct : imageSrc}
      className="product_item_default_img"
      alt="Product"
      width={Number(size) ?? 48}
      style={{ ...(filter ? { filter } : {}) }}
      height={size ? 'auto' : 48}
      onError={(e) => {
        console.warn(`Image failed to load: ${imageSrc}`);
        e.currentTarget.onerror = null;
        e.currentTarget.src = SVGS.DefaultProduct;
      }}
    />
  );
};
